
const NotFound = () => <section className="content-box"><h1>404 Page Not Found</h1></section>

export default NotFound;